import React from 'react';
import ModalWithoutTitle from 'components/ui/ModalWithoutTitle';

import { useNavigate, useParams } from 'react-router-dom';

import useEnterpriseBrief from 'components/Common/Enterprises/Hooks/useEnterpriseBrief';

import routes from 'app/routes';
import Form from '../Form/Index';

import NoData from '../../NoData';

import actions from '../../Actions';

export default function Edit({ enterpriseId, refresh }) {
  const navigate = useNavigate();

  const { enterpriseBriefId } = useParams();

  const brief = useEnterpriseBrief(enterpriseBriefId);

  const onSave = (values) => {
    actions.update(enterpriseBriefId, values, () => {
      navigate(routes.admin.enterprise_briefs.index(enterpriseId));
      refresh();
    }, () => {
      alert('error');
    });
  };

  return (
    <ModalWithoutTitle
      show
      onHide={() => navigate(-1)}
    >
      {brief === null ? <NoData /> : <Form onSave={onSave} data={brief.attributes} enterpriseId={enterpriseId} />}

    </ModalWithoutTitle>
  );
}
